<template>
  <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10">
    <!-- Header Section -->
    <div class="d-flex align-center py-5 mb-6 animate-fade-in-up stagger-1" style="border-bottom: 1px solid rgba(255, 255, 255, 0.08)">
      <v-btn class="premium-btn-icon-circle mr-4" icon @click="$router.push('/user')">
        <v-icon color="white">mdi-chevron-left</v-icon>
      </v-btn>
      <h1 class="premium-title-gradient text-h5 font-weight-black mb-0">Deine Einkäufe</h1>
    </div>

    <!-- Purchases List -->
    <v-row v-if="purchases && purchases.length" class="animate-fade-in-up stagger-2">
      <v-expansion-panels v-model="purchasesModel" dark class="premium-panels">
        <v-expansion-panel v-for="(purchase, i) of purchases" :key="i + '-purchaseIndex'" class="glass-card mb-4 overflow-hidden">
          <v-expansion-panel-header class="py-5 px-6 white--text font-weight-bold">
            <div class="d-flex align-center justify-space-between width-100 pr-4">
              <div>
                <span class="grey--text text--lighten-1 text-caption d-block mb-1">Einkauf vom</span>
                <span class="text-subtitle-1">{{ $moment(purchase.createdAt).format("DD.MM.YY [um] HH:mm") }} Uhr</span>
              </div>
              <div class="text-right">
                <span class="grey--text text--lighten-1 text-caption d-block mb-1">Anzahl Produkte</span>
                <span class="text-subtitle-1">{{ purchase.products.length }} {{ purchase.products.length > 1 ? "Produkte" : "Produkt" }}</span>
              </div>
            </div>
            <template v-slot:actions>
              <v-btn icon color="white" class="premium-btn-icon-circle mr-2" small @click.stop="pushToRoute(purchase)">
                <v-icon size="18">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="px-2 pb-4">
            <v-divider style="background-color: rgba(255, 255, 255, 0.08)" class="mb-4"></v-divider>

            <div
              v-for="(product, index) of purchase.products"
              :key="'Product-' + index"
              class="d-flex align-center justify-space-between pa-4 mb-2 rounded-xl"
              style="background: rgba(0, 0, 0, 0.15); border: 1px solid rgba(255, 255, 255, 0.03)">
              <div>
                <h4 class="white--text font-weight-bold mb-1">{{ product.title }}</h4>
                <span style="color: #00b074; font-weight: 700; font-size: 0.95rem">{{ product.price }} CHF</span>
              </div>

              <v-btn icon color="white" class="premium-btn-icon-circle" small @click="getDownloadForProduct(purchase, index)">
                <v-icon size="18">mdi-file-download-outline</v-icon>
              </v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <!-- Empty State -->
    <v-row v-else class="justify-center mt-12 animate-fade-in-up stagger-2">
      <div class="glass-card pa-8 text-center" style="max-width: 500px; width: 100%">
        <v-icon size="48" color="grey lighten-1" class="mb-4">mdi-ticket-outline</v-icon>
        <h3 class="text-h6 font-weight-bold white--text mb-2">Keine Einkäufe gefunden</h3>
        <p class="grey--text text--lighten-1 mb-0">Bisher wurden noch keine Gutscheine oder Abonnements mit diesem Account gekauft.</p>
      </div>
    </v-row>
  </div>
</template>

<script>
import api from "@/api"

export default {
  data() {
    return {
      purchasesModel: null,
      purchases: [],
    }
  },
  async created() {
    this.purchases = await api.fetchAllPurchasesDetails()
    if (!this.purchases || !this.purchases.length) {
      this.$toast.error("Es wurden keine Einkäufe gefunden.")
      this.$router.push("/user")
    }
  },
  methods: {
    pushToRoute(purchase) {
      this.$router.push("/shop/purchase/infos/" + purchase.transactionId)
      console.log(purchase)
    },
    async getDownloadForProduct(purchase, index) {
      this.$toast.success("Dein Ausdruck wird generiert")
      await api.downloadRealVoucher({ _id: purchase._id, product: index })
    },
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.width-100 {
  width: 100%;
}

.premium-title-gradient {
  background: linear-gradient(135deg, #ffffff 40%, #a3e635 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-family);
  font-weight: 800 !important;
  letter-spacing: -0.03em;
  text-transform: none !important;
}

::v-deep .premium-btn-icon-circle {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 50% !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-icon-circle:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.08) translateY(-1px) !important;
}

::v-deep .glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

::v-deep .glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01) !important;
}

/* Custom visual updates to standard vuetify panels */
::v-deep .premium-panels .v-expansion-panel {
  background-color: var(--bg-card) !important;
}

::v-deep .premium-panels .v-expansion-panel::before {
  box-shadow: none !important;
}

::v-deep .premium-panels .v-expansion-panel-header__icon {
  margin-left: 8px !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
